import * as actiontypes from '../../constants/actionType';

export function setTrayID(trayID) {
  return {type: actiontypes.SET_TRAY_ID, id: trayID};
}

export function setTrayType(trayType) {
  return {type: actiontypes.SET_TRAY_TYPE, trayType};
}

export function setTrayData(tray) {
  return {type: actiontypes.SET_TRAY_DATA, tray};
}

export const setIsTrayAttached = (isAttached) => ({type: actiontypes.SET_IS_TRAY_ATTACHED, isAttached});

export function setDefaultDeckInsert(deckinsert) {
  return (dispatch) => {
    const deckList = [];
    if (deckinsert && deckinsert.length > 0) {
      for (let index = 0; index < deckinsert.length; index += 1) {
        const deck = deckinsert[index];
        const newDeck = {
          ID: deck.id,
          xPos: deck.calibrationData.x,
          yPos: deck.calibrationData.y,
          zPos: deck.calibrationData.z,
          isCalibrated: deck.isCalibrated,
          isSelected: false,
        };
        deckList.push(newDeck);
      }
    }

    dispatch({type: actiontypes.SET_DEFAULT_DECK_INSERT, deckInsert: deckList});
  };
}

export function setDeckInsert(deckinsert) {
  return (dispatch, getState) => {
    const deckList = [];
    if (deckinsert.length > 0) {
      deckinsert.map((deck) => deckList.push(deck));
    }

    const state = getState();
    const {appState} = state;

    dispatch({type: actiontypes.SET_DECK_INSERT, trayId: appState.trayID, deckInsert: deckList});
  };
}

export function setDeckInsertXValue(deckInsertId, value) {
  return {type: actiontypes.SET_DECK_INSERT_X_VALUE, deckInsertId, value};
}

export function setDeckInsertYValue(trayId, deckInsertId, value) {
  return {type: actiontypes.SET_DECK_INSERT_Y_VALUE, deckInsertId, value};
}

export function setDeckInsertZValue(deckInsertId, value) {
  return {type: actiontypes.SET_DECK_INSERT_Z_VALUE, deckInsertId, value};
}

export function setDeckInsertXYZValue(deckInsertId, xPos, yPos, zPos) {
  return {type: actiontypes.SET_DECK_INSERT_XYZ_VALUE, deckInsertId, xPos, yPos, zPos};
}

export function setRollPitchYaw(rollPitchYaw) {
  return {type: actiontypes.SET_ROLL_PITCH_YAW, rollPitchYaw};
}

export function setThresholdRPY(thresholdRPY) {
  return {type: actiontypes.SET_THRESHOLD_RPY, thresholdRPY};
}

export function setLastCalibrated(lastCalibrated) {
  return {type: actiontypes.SET_LAST_CALIBRATED, lastCalibrated};
}

export function selectDeckInsertCalibrated(deckInsertId, status) {
  return {type: actiontypes.SET_DECK_INSERT_CALIBRATED, deckInsertId, status};
}

export function selectDeckInsertById(deckInsertId, status = true) {
  return {type: actiontypes.SELECT_DECK_INSERT_BY_ID, deckInsertId, status};
}

export function resetTrayCalibrationState() {
  return {type: actiontypes.RESET_TRAYCALIBRATION};
}

export function restoreTrayCalibrationState(state) {
  return {type: actiontypes.RESTORE_TRAYCALIBRATION_STATE, state};
}

export function setCurrentPosisition(currentPosition) {
  return {type: actiontypes.SET_CURRENT_POSITION, currentPosition};
}
